import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { ComponentStoreFactory } from '../../../../../shared/store/common/component-store.factory';
import { ServiceService } from '../../../../../../services/service.service';
import {
    ServiceNursingCareDiagnosisCodeGridObject, ServiceNursingCareDiagnosisCodeObject,
} from '@libs/types/src/services/object-type/service/service-nursing-care-diagnosis-code.object';
import {
    ServiceNursingCareDiagnosisGroupGridObject, ServiceNursingCareDiagnosisGroupObject,
} from '@libs/types/src/services/object-type/service/service-nursing-care-diagnosis-group.object';

interface State {
    serviceNursingCareDiagnosisCodes: ServiceNursingCareDiagnosisCodeGridObject | null,
    serviceNursingCareDiagnosisGroups: ServiceNursingCareDiagnosisGroupGridObject | null,
}

const defaultState: State = {
    serviceNursingCareDiagnosisCodes: null,
    serviceNursingCareDiagnosisGroups: null,
};

@Injectable()
export class ServiceNursingDiagnosisDetailPageStore extends ComponentStoreFactory<State> {

    public diagnosis$ = this.data.serviceNursingCareDiagnosisCodes$.firstGridItem<ServiceNursingCareDiagnosisCodeObject>();

    public readonly diagnosisGroups$ = this.data.serviceNursingCareDiagnosisGroups$.gridItems<ServiceNursingCareDiagnosisGroupObject>();

    constructor() {
        super(defaultState, inject(Store), inject(ServiceService));
    }

}
